// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/_index.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/_index.tsx");
  import.meta.hot.lastModified = "1773385375631.8572";
}
// REMIX HMR END

import { json, redirect } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import { makeDomainFunction } from "domain-functions";
import { formAction } from "~/components/forms/form-action.server";
import { schema } from "~/routes/audit";
import getToken from "~/drupal/auth.server";
import { getClient } from "~/drupal/client.server";
import { metaTags } from "drupal-remix";
import { Fragment } from "react";
import Footer from "~/components/navigation/Footer";
import Navbar from "~/components/navigation/Navbar";
import NodePageComponent from "~/components/node/NodePage";
import Heading from "~/components/Heading";
import QuickAccessModal from "~/components/QuickAccessModal";
import { InfoFragment } from "~/drupal/fragments/info.server";
import { FooterMenuFragment, MainMenuFragment } from "~/drupal/fragments/menus.server";
import { RouteInternalFragment } from "~/drupal/fragments/nodes.server";
import { AuditService } from "~/services/audit.server";
export const meta = ({
  data
}) => {
  return metaTags({
    tags: data.node.metatag,
    metaTagOverrides: {
      MetaTagLink: {
        canonical: [{
          pattern: "live-octahedroid.pantheonsite.io",
          replacement: "octahedroid.com"
        }, {
          pattern: "/home",
          replacement: "/"
        }]
      },
      MetaTagProperty: {
        "og:url": [{
          pattern: "live-octahedroid.pantheonsite.io",
          replacement: "octahedroid.com"
        }, {
          pattern: "/home",
          replacement: "/"
        }]
      }
    }
  });
};
export const loader = async ({
  context,
  request
}) => {
  const path = "home";
  const token = await getToken(context);
  const drupalClient = getClient(token, context);
  const {
    searchParams
  } = new URL(request.url);
  const url = searchParams.get("url");
  const device = searchParams.get("device") || "desktop";
  const reportType = searchParams.get("reportType");
  const {
    route,
    menu,
    info
  } = await drupalClient.query({
    route: {
      __args: {
        path: path
      },
      __typename: true,
      on_RouteInternal: {
        ...RouteInternalFragment
      }
    },
    menu: {
      __args: {
        name: "MAIN"
      },
      ...MainMenuFragment
    },
    info: {
      ...InfoFragment
    }
  });
  const {
    menu: footer
  } = await drupalClient.query({
    menu: {
      __args: {
        name: "FOOTER"
      },
      ...FooterMenuFragment
    }
  });
  if (!route || route.__typename !== "RouteInternal" || !route.entity) {
    return redirect("/404");
  }
  const pageData = {
    node: route.entity,
    menu,
    footer,
    info,
    environment: context.ENVIRONMENT
  };
  if (url && reportType) {
    const audit = await AuditService.findAuditByParams({
      reportType,
      url,
      device,
      auditAuthorizationToken: context.AUDIT_AUTHORIZATION_TOKEN
    });
    if (audit.error) {
      return json({
        ...pageData,
        audit: {
          error: audit.error
        }
      }, {
        status: 200
      });
    }
    const {
      crux,
      psi,
      opengraph
    } = audit;
    return json({
      ...pageData,
      audit: {
        crux: crux ? crux.coreWebVitals : undefined,
        psi: psi ? psi.pageSpeedInsights : undefined,
        opengraph: opengraph ? opengraph.cards : undefined,
        reportId: audit.reportId
      }
    }, {
      status: 200
    });
  }
  return json({
    ...pageData,
    audit: null
  }, {
    status: 200
  });
};
const mutation = makeDomainFunction(schema)(async ({
  intent,
  url
}) => {
  return {
    success: true
  };
});
export const action = async ({
  request,
  context: environment
}) => {
  return await formAction({
    request,
    schema: schema,
    mutation,
    environment
  });
};
export default function Index() {
  _s();
  const {
    node,
    menu,
    footer,
    info,
    environment
  } = useLoaderData();
  if (!node) {
    return <Heading tag="h1">Not Found</Heading>;
  }
  return <Fragment>
      <Navbar navigation={menu?.items} information={info} />
      <NodePageComponent node={node} environment={environment} />
      <QuickAccessModal />
      <Footer navigation={footer?.items} />
    </Fragment>;
}
_s(Index, "ZiEFJwtHvpl9+1+Eyj91Bm6/Z5g=", false, function () {
  return [useLoaderData];
});
_c = Index;
var _c;
$RefreshReg$(_c, "Index");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;